<template>
  <div v-if="visible">
    <span>
      {{ sqwizPage.label }}
    </span>

    <span>
      ({{ visible }} objav)
    </span>

    <icon
      scale="1"
      name="arrow-right" />

    <input-select
      :inputName="sqwizPage.id"
      transparent
      class="select-input"
      variant= "standardInput"
      inputPlaceholder="Wordpress"
      smaller
      v-on="$listeners"
      :selectOptions="wordpressUsers" />

  </div>
</template>

<script>
import InputSelect from '@/components/standard/input/InputSelect'
import gql from 'graphql-tag'

export default {
  data () {
    return {
      mediaPlanEvents: {}
    }
  },

  methods: {
    refetch () {
      this.$apollo.queries.mediaPlanEvents.refetch()
    }
  },

  created () {
    this.$parent.$on('refetch', this.refetch)
  },

  beforeDestroy () {
    this.$parent.$off('refetch', this.refetch)
  },

  computed: {
    visible () {
      return (this.mediaPlanEvents.info || {}).total
    }
  },

  props: {
    sqwizPage: {
      type: Object,
      default: () => ({})
    },
    wordpressUsers: {
      type: Array,
      default: () => []
    },
    userId: {
      type: String,
      requited: true
    }
  },

  components: {
    InputSelect
  },

  apollo: {
    mediaPlanEvents: {
      query: gql`query ($ownedBy: [UUID!], $credentials: [UUID!]) {
        mediaPlanEvents (ownedBy: $ownedBy, credentials: $credentials, published: true) {
          info {
            total
          }
        }
      }`,

      variables () {
        return {
          ownedBy: this.userId,
          credentials: this.sqwizPage.id
        }
      },

      result (ApolloQueryResult) {
        if (!ApolloQueryResult.loading) {
          const { data: { mediaPlanEvents: { info: { total } } } } = ApolloQueryResult
          if (!total) {
            this.$emit('update', { empty: true, id: this.sqwizPage.id })
          } else {
            this.$emit('update', { empty: false, id: this.sqwizPage.id })
          }
        }
      },

      fetchPolicy: 'cache-and-network'
    }
  }
}
</script>

<style scoped>
span {
  margin-right: 15px;
}
div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/display/migration/sqwiz/Row.vue?7ce3b484